import Controller from '@ember/controller';

export default class HotelErrorController extends Controller {
  queryParams = ['reason'];

  reason = 'unknown';
}
